// One WebSocket toward the game server. Mirror of multiplayer/OnlineClient.java on Android: one
// instance is one connection, a reconnection always builds a new one, and a disconnection is
// reported exactly once per connection (never after an intentional close).

export class Connection {
  #socket;
  #handlers;
  #closedByUser = false;
  #disconnectDelivered = false;

  // handlers: { onOpen, onMessage, onDisconnected }
  constructor(url, handlers) {
    this.#handlers = handlers;
    this.#socket = new WebSocket(url);
    this.#socket.addEventListener('open', () => this.#handlers.onOpen?.());
    this.#socket.addEventListener('message', (event) => {
      let message;
      try {
        message = JSON.parse(event.data);
      } catch {
        // A malformed frame is the server's problem, not a reason to tear down a working session
        console.error('malformed message from server', event.data);
        return;
      }
      this.#handlers.onMessage?.(message);
    });
    // 'error' is always followed by 'close', so only 'close' delivers the event
    this.#socket.addEventListener('close', () => this.#deliverDisconnect());
    this.#socket.addEventListener('error', () => {});
  }

  #deliverDisconnect() {
    if (this.#closedByUser || this.#disconnectDelivered) {
      return;
    }
    this.#disconnectDelivered = true;
    this.#handlers.onDisconnected?.();
  }

  send(message) {
    if (this.#socket.readyState !== WebSocket.OPEN) {
      // The connection just dropped: the close event drives the reconnection
      return false;
    }
    this.#socket.send(JSON.stringify(message));
    return true;
  }

  close() {
    this.#closedByUser = true;
    try {
      this.#socket.close();
    } catch {
      // Already closing
    }
  }
}
